import React from 'react';

import './professionalCaption.scss';

function ProfessionalCaption() {
    return (
        <div className='service-caption-header'>
            <div className='service-capt'>
                Kadoshi
                <span>Services</span>
                <span className='service-hiven'>!</span>
            </div>
            <div className='service-text'>
                Explore our massive database of qualifield professionalsin their various fields of
                enterprises. Simply search or select a category and get acces to them!
            </div>
        </div>
    )
}

export default ProfessionalCaption;
